import React, {FC, useMemo, useState} from "react";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

type componentProps = {
  id?:string,
  style?:React.CSSProperties | CSS.Properties,
  color?:string,
  backgroundColor?:string,
  className?:string,
  children?:React.ReactNode, // | React.ReactElement<any> | React.CSSProperties
  hasStyleSizeVariable?:boolean
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const {$, rz} = window;

const DivE:FC<componentProps> = (props) => {
  // const customStyle = (props.style ? {...props.style} : undefined);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [theme, setTheme] = useState($("html").attr("data-theme") || "dark");

  const styl = useMemo<React.CSSProperties | CSS.Properties>(() => {
    const est:React.CSSProperties | CSS.Properties = {...props.style};
    let clr:string; const allc = (props.color || "").split("|"); if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    if (!est?.color && clr) { est.color = clr }
    let bclr:string; const allb = (props.backgroundColor || "").split("|"); if (allb.length > 1) { bclr = (theme === "dark" ? allb[1] : allb[0]) } else { bclr = allb[0] }
    if (!est?.backgroundColor && bclr) { est.backgroundColor = bclr }
    return est;
  }, [props, theme]);

  if (props.hasStyleSizeVariable && props.id) {
    return (
      <div {...props} style={styl} >
        <style>
          { // @ts-ignore
            ":root{--" + props.id + "-height: " + (props?.style?.height ?? 0) + "; --" + props.id + "-width: " + (props?.style?.width ?? 0) + ";}"
          }
        </style>
        {props?.children}
      </div>
    );
  }

  return (
    <div {...props} style={styl} >
      {props?.children}
    </div>
  );
};

export default DivE;
